module.exports = __webpack_public_path__ + "img/sel_Beijing--.c4af083f.png";